import React, { Fragment, useRef } from "react";
import { isMobile } from "react-device-detect";
import { useTranslation } from "react-i18next";

import CatchStoryItem from "components/boards/post/catchstory/CatchStoryItem";

import SectionTitle from "pages/station/home/section/SectionTitle";
import { gtag } from "helpers";
import { Swiper, SwiperSlide } from "swiper/react/swiper-react";
import { Controller, Navigation, Pagination } from "swiper";


const CatchStorySection = ({loading, catchstorys, catchstory_total, sliderPerView=5}) => {
	const inflowPath = ["separate", "station", "home", "story"];
	const { t } = useTranslation();

    const prefBtnRef = useRef(null);
    const nextBtnRef = useRef(null);

    const swiperSettings = {
        className: '',
        slidesPerView: sliderPerView,
        modules: [Controller, Navigation,  Pagination],
        wrapperTag: "ul",
        initialSlide: 0,
        spaceBetween: 18,
        navigation: { // 네비게이션 적용, < >
            prevEl: prefBtnRef.current,
            nextEl: nextBtnRef.current,
        },
        pagination: { clickable: true, el: '.swiper-pagination', type: 'bullets' },
    }

    // 로딩 중
    if (loading) {
        if (isMobile) {
            return null;
        }

        {/* 로딩 ui 받아야함 */}
        return (
            <Fragment>
                <SectionTitle className="uclip" title={t("Catch 스토리")} to={`/${global.bj_id}/vods/catchstory`} />
                <section className="vod-list catch">
                    <ul>
                        {[0, 1, 2, 3].map((value, index) => (
                            <li key={index}>
                                <div className="ld-grid-row-2">
                                    <div>
                                        <span />
                                    </div>
                                    <div className="list">
                                        <span />
                                        <span />
                                    </div>
                                </div>
                            </li>
                        ))}
                    </ul>
                </section>
            </Fragment>
        );
    }

    // 데이터가 없을 경우
    if(catchstorys === null || catchstorys.length === 0) {
        return null;
    }

    // 유저 캐치스토리 데이터 노출
    return (
        <Fragment>  
            {/*모바일 메인 > 캐치스토리 리스트*/}
            {isMobile && (
                <div className="catch_hz_box catch_story_box">
                    {/* 유저 캐치스토리 제목 영역 */}
                    <SectionTitle
                        title={t("Catch 스토리")}
                        to={`/${global.bj_id}/vods/catchstory`}
                    />

                    {/* 유저 캐치스토리 데이터 노출 영역 */}
                    <div data-type ={"scroll-horizon"} className="catch_list_horizon">
                        <ul className="scroll-innr">
                            {catchstorys.map((vod, index) => (
                                <li key={vod.title_no}>
                                    <CatchStoryItem
                                        location={"home"}
                                        inflowPath={inflowPath}
                                        vod={vod}
                                        authority={vod.authority}
                                        storyOrderInTotal={index+1}
                                        total={catchstory_total}
                                    />
                                </li>
                            ))}
                        </ul>
                    </div>
                </div>
            )}
    
            {/*PC 메인 > 캐치스토리 리스트*/}
            {!isMobile && (
                <Fragment>  
                    {/* 유저 캐치스토리 제목 영역 */}    
                    <SectionTitle
                        className="tit_catch"
                        title={t("Catch 스토리")}
                        to={`/${global.bj_id}/vods/catchstory`}
                    />
                    <div className="catch_hz_box catch_story_box" onClick={gtag('home', 'userclip')}>
                        <div catch="list">
                            <Swiper
                                {...swiperSettings}
                            >
                                {catchstorys.map((vod, index) => (
                                    <SwiperSlide tag={"li"} key={`home_catch_story_${index}`}>
                                        <CatchStoryItem
                                            location={"home"}
                                            inflowPath={inflowPath}
                                            vod={vod}
                                            authority={vod.authority}
                                            storyOrderInTotal={index}
                                            total={catchstory_total}
                                        />
                                    </SwiperSlide>
                                ))}
                            </Swiper>
                        </div>
                        <button type="button" ref={prefBtnRef} className="catch-prev">이전</button>
                        <button type="button" ref={nextBtnRef} className="catch-next">다음</button>
                    </div>
                </Fragment>
            )}
        </Fragment>
    );
}

export default CatchStorySection;
